/* eslint-disable max-len */
import { cn } from '../cn';

export const IconClose = ({ className = '' }): JSX.Element => (
  <svg role='img' className = {cn('inline', className)} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M4 4L20 20M4 20L20 4.00002' stroke='currentColor' strokeWidth='2' strokeLinecap='round'/>
  </svg>
);
